import { useActions } from '@/hooks/use-store';
import { getRequiredFields } from '..';

/**
 *
 * Toggle de campos obrigatórios dinamicos.
 * Existe campos que variam a sua obrigatoriedade conforme
 * algumas regras.
 *
 * @param {String}  model ( user, client, etc )
 * @param {Array}   group ( { field: 'Teste', isRequired: true } )
 *
*/
const toggleRequiredFields = async ( model, { field, isRequired, isRequiredOnEdit = false }) => {
    const requiredFields = await getRequiredFields( model );
    const existFieldPosition = requiredFields.findIndex( required => required.field === field );

    // se deixar de ser obrigatório é
    // removido do array de campos em falta
    // e removido do payload.
    if ( ~existFieldPosition && !isRequired ) {
        requiredFields.splice( existFieldPosition, 1 );
        const { actions } = useActions();
        actions( 'resetError', { type: 'missing', fieldName: field });
        actions( 'deleteField', { name: field });
        return;
    }

    // validação se já não existe no array
    // campo.
    if ( !~existFieldPosition && isRequired )
        requiredFields.push({ field, isRequiredOnEdit });
};

/**
 * [function]
 * Toggle de campos obrigatórios dinamicos.
 * Existe campos que variam a sua obrigatoriedade conforme
 * algumas regras.
 *
 * @param {String}  model ( user, client, etc )
 * @since 1.1.0
 * @category function
 * @author Tiago Martinho
 *
*/
const resetRequiredFields = async model => {
    const requiredFields = await getRequiredFields( model );
    requiredFields.length = 0;
};

export {
    toggleRequiredFields,
    resetRequiredFields
};